module.exports = __webpack_public_path__ + "media/images/profile_picture-f7149c33d7a62d5d5c5fe807f3fe721c.jpg";